export const DEFAULT_DATE_TIME_FORMAT = 'Y-MM-DD HH:mm:ss';

// for datepicker
export const MDY_DATE_FORMAT = 'Y-MM-DD';
export const TIME_FORMAT = 'HH:mm zz';
export const REPORT_TIME_FORMAT = 'HH:mm';
